export enum CardType {
  UNIT = 'UNIT',
  SPELL = 'SPELL',
  ARTIFACT = 'ARTIFACT',
  LEADER = 'LEADER',
}

export enum Faction {
  HUMAN = 'HUMAN',
  DEMON = 'DEMON',
  ELF = 'ELF',
  DRAGON = 'DRAGON',
  UNDEAD = 'UNDEAD',
  NEUTRAL = 'NEUTRAL',
}

export enum Rarity {
  COMMON = 'COMMON',
  UNCOMMON = 'UNCOMMON',
  RARE = 'RARE',
  LEGENDARY = 'LEGENDARY',
  MYTHIC = 'MYTHIC',
}

export enum BattleStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export interface Card {
  id: string;
  cardId: string;
  name: string;
  cost: number;
  type: CardType;
  faction: Faction;
  strength?: number;
  goldCost?: number;
  effect?: CardEffect;
  skill?: string;
  epicText?: string;
  imageUrl?: string;
  imagePath?: string;
  rarity: Rarity;
  edition: string;
  editionName?: string;
  race?: string;
}

export interface CardEffect {
  description: string;
  trigger?: string;
  cost?: string;
  effect?: string;
}

export interface Deck {
  id: string;
  name: string;
  description?: string;
  format: string;
  isPublic: boolean;
  userId: string;
  cards: DeckCard[];
  createdAt: string;
  updatedAt: string;
}

export interface DeckCard {
  cardId: string;
  card: Card;
  quantity: number;
}

export interface DeckInput {
  name: string;
  description?: string;
  format: string;
  isPublic: boolean;
  cards: { cardId: string; quantity: number }[];
}

export interface Space {
  id: string;
  name: string;
  slug: string;
  description?: string;
  logoUrl?: string;
  isPublic: boolean;
  config: SpaceConfig;
  memberCount: number;
  createdAt: string;
}

export interface SpaceConfig {
  maxCards: number;
  maxCopies: number;
  maxReserve: number;
  allowedFactions: Faction[];
  bannedCards: string[];
  bestOf: number;
  timeLimit?: number;
}

export interface Battle {
  id: string;
  status: BattleStatus;
  winnerId?: string;
  deck1Id: string;
  deck2Id?: string;
  deck1: Deck;
  deck2?: Deck;
  turns: number;
  battleLog?: BattleLogEntry[];
  createdAt: string;
}

export interface BattleLogEntry {
  turn: number;
  player: string;
  action: string;
  details?: Record<string, unknown>;
}

export interface EvolutionResult {
  id: string;
  status: 'running' | 'completed' | 'error';
  generation: number;
  bestDeck: Deck;
  bestFitness: number;
  populationSize: number;
  startTime: string;
}

export interface ApiResponse<T> {
  data: T;
  success: boolean;
  message?: string;
}
